var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVoucher32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 28,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29.83 20.006c-.375 1.039-1.337 1.58-1.45 1.58L23.1 23.95c-10.23 4.17-10.042 4.361-11.405 3.849-1.506-.566-.588.535-8.254-13.062-.537-.936-.64-2.504.097-3.681C8.644 2 9.442.023 11.575.002c.14.01-.95-.219 10.633 2.334.977.228 2.178 1.148 2.761 2.415.023.048-.34-.942 4.78 13.124.303.68.332 1.435.081 2.13Z",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.359 11.688v13.437a2.868 2.868 0 0 1-2.859 2.871H2.858A2.868 2.868 0 0 1 0 25.125V11.688c0-1.263.531-2.477 1.458-3.33C10.228.29 10.162.016 11.576.002c1.636 0 1.126-.107 10.324 8.356a4.535 4.535 0 0 1 1.459 3.33Z",
  fill: "url(#b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.36 11.688v13.437a2.868 2.868 0 0 1-2.859 2.871H11.68V.001c1.514-.003 1.234.089 10.22 8.357a4.536 4.536 0 0 1 1.46 3.33Z",
  fill: "url(#c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.56 5.564c0 1.162-1.761 1.162-1.761 0s1.76-1.161 1.76 0Z",
  fill: "#00357B"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.68 6.443c0-1.864-.095-1.823.256-1.72.979.32.734 1.72-.256 1.72Z",
  fill: "#001737"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.649 12 10.37 22.195a.879.879 0 0 1-1.621-.68l4.279-10.193a.88.88 0 0 1 1.62.68Z",
  fill: "#fff"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "m14.648 12-2.968 7.073v-4.542l1.347-3.21a.88.88 0 0 1 1.621.68ZM10.059 13.383c0-1.696-1.243-3.075-2.77-3.075s-2.77 1.38-2.77 3.075c0 1.695 1.243 3.075 2.77 3.075s2.77-1.38 2.77-3.075ZM7.289 14.7c-.548 0-1.012-.604-1.012-1.318 0-.715.464-1.318 1.012-1.318.549 0 1.012.603 1.012 1.318 0 .714-.463 1.318-1.012 1.318ZM16.157 17.277c-1.527 0-2.77 1.38-2.77 3.075 0 1.696 1.243 3.075 2.77 3.075s2.77-1.379 2.77-3.075c0-1.695-1.242-3.075-2.77-3.075Zm0 4.393c-.548 0-1.011-.603-1.011-1.318 0-.714.463-1.318 1.011-1.318.549 0 1.012.604 1.012 1.318 0 .715-.463 1.318-1.012 1.318Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 5.933,
  y1: -0.277,
  x2: 17.272,
  y2: 27.689,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00FFC2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009DDC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 3.893,
  y1: 0.585,
  x2: 19.786,
  y2: 24.985,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F39221"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FC1266"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 13.626,
  y1: 0.584,
  x2: 30.413,
  y2: 13.47,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F39221"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FC1266"
})))));
export default SvgVoucher32;